import { Dayjs } from 'dayjs';
import { DeviceProcModes } from '../../devices/device.helper';
import { CalendarTaskListDto } from '@common/generated-api/models/calendar-task-list-dto';
import { CalendarTaskItemDto } from '@common/generated-api/models/calendar-task-item-dto';
import { EventOverlaps } from '../task-editor/services/task-sched.service';

export enum CalPeriodTypes {
  day = 'day',
  week = 'week',
  month = 'month'
}

export enum SurfaceTypes {
  area = 'AREA',
  air = 'AIR'
}

export interface ICalBoundaries {
  periodType: CalPeriodTypes,
  startDO: Dayjs;
  endDO: Dayjs;
  start: number;
  end: number
}


export interface ICalDay {
  title: string;
  outsided?: boolean;
  date: Date;
  events: ICalEvent[];
  start: number;
  end: number;
}

export interface ITaskProcParams {
  surface: SurfaceTypes;
  modeName: DeviceProcModes;
  surfaceSelectionDisabled: boolean;
}

export interface IProcModeWithId {
  id: number;
  value: DeviceProcModes;
  surfaceType: SurfaceTypes;
}

export interface InspectedTaskData {
  hasOverlaps: boolean;
  overlaps: EventOverlaps;
}

export interface ICalEvent extends CalendarTaskListDto {
  status?: CalTaskStatusEnum;
  inspectedTaskData?: InspectedTaskData
}

export interface ICalTaskItem extends CalendarTaskItemDto {
  status?: CalTaskStatusEnum;
}

export enum CalTaskStatusEnum {
  success = 'SUCCESS',
  failed = 'FAILED',
  process = 'PROCESS',
  future = 'FUTURE'
}
